(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pps-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pps-footer-discount')) {
    customElements.define('pps-footer-discount', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('.pps-footer__copy-code');
        const code = this.querySelector('.pps-footer__discount-code');
        const status = this.querySelector('.pps-footer__copy-status');
        if (!button || !code || !status) return;

        button.hidden = false;
        button.onclick = async () => {
          if (button.disabled) return;
          button.disabled = true;
          status.textContent = '';
          let copied = false;

          try {
            if (navigator.clipboard && window.isSecureContext) {
              await navigator.clipboard.writeText(code.value);
              copied = true;
            }
          } catch (error) {}

          if (!copied) {
            code.focus();
            code.select();
            code.setSelectionRange(0, code.value.length);
            try {
              copied = document.execCommand('copy');
            } catch (error) {}
          }

          status.textContent = copied
            ? button.dataset.copiedLabel
            : button.dataset.copyError;
          button.disabled = false;
          if (copied) button.focus({ preventScroll: true });
        };
      }

      disconnectedCallback() {
        const button = this.querySelector('.pps-footer__copy-code');
        if (button) button.onclick = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pps-gang-sheet"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      const galleries = root.matches?.('[data-pps-gallery]') ? [root] : root.querySelectorAll('[data-pps-gallery]');
      galleries.forEach((gallery) => {
        if (gallery.dataset.ppsInitialized) return;
        gallery.dataset.ppsInitialized = 'true';
        gallery.querySelectorAll('.pps-pdp__app .gs--button').forEach((control) => {
          if (control.tagName !== 'DIV') return;
          control.setAttribute('role', 'button');
          control.tabIndex = 0;
          control.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            control.click();
          });
        });
        const image = gallery.querySelector('.pps-pdp__main-image');
        const thumbnails = gallery.querySelector('.pps-pdp__thumbnails');
        if (!image || !thumbnails) return;
        thumbnails.hidden = false;
        thumbnails.addEventListener('click', (event) => {
          const button = event.target.closest('[data-image-url]');
          if (!button || !thumbnails.contains(button)) return;
          const url = new URL(button.dataset.imageUrl, window.location.href);
          image.srcset = [320,480,640,800,1000,1200,1400].map((width) => {
            url.searchParams.set('width', width);
            return `${url.href} ${width}w`;
          }).join(', ');
          image.src = button.dataset.imageUrl;
          image.alt = button.dataset.imageAlt;
          image.width = Number(button.dataset.imageWidth);
          image.height = Number(button.dataset.imageHeight);
          thumbnails.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once:true});
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pps-pre-cut"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      const galleries = root.matches?.('[data-pps-gallery]') ? [root] : root.querySelectorAll('[data-pps-gallery]');
      galleries.forEach((gallery) => {
        if (gallery.dataset.ppsInitialized) return;
        gallery.dataset.ppsInitialized = 'true';
        gallery.querySelectorAll('.pps-precut__app .gs--button').forEach((control) => {
          if (control.tagName !== 'DIV') return;
          control.setAttribute('role', 'button');
          control.tabIndex = 0;
          control.addEventListener('keydown', (event) => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            event.preventDefault();
            control.click();
          });
        });
        const image = gallery.querySelector('.pps-precut__main-image');
        const thumbnails = gallery.querySelector('.pps-precut__thumbnails');
        if (!image || !thumbnails) return;
        thumbnails.hidden = false;
        thumbnails.addEventListener('click', (event) => {
          const button = event.target.closest('[data-image-url]');
          if (!button || !thumbnails.contains(button)) return;
          const url = new URL(button.dataset.imageUrl, window.location.href);
          image.srcset = [320,480,640,800,1000,1200,1400].map((width) => {
            url.searchParams.set('width', width);
            return `${url.href} ${width}w`;
          }).join(', ');
          image.src = button.dataset.imageUrl;
          image.alt = button.dataset.imageAlt;
          image.width = Number(button.dataset.imageWidth);
          image.height = Number(button.dataset.imageHeight);
          thumbnails.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once:true});
    else initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
